function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.104)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.195,74.68,35.044,87.1a11,11,0,0,0-2.858.7A11.182,11.182,0,1,0,45.706,92l8.732-21.083Q47.152,72.978,40.195,74.68Z",
  transform: "translate(48.581 136.734)",
  fill: "#15091b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.6,57.809a11.024,11.024,0,0,0-2.539,1.485L85.482,52.978Q79.4,56.635,72.85,60.266l22.96,9.956a11.51,11.51,0,0,0,.586,2.05A11.127,11.127,0,1,0,102.588,57.8Z",
  transform: "translate(140.467 102.15)",
  fill: "#15091b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.484,50.2c-6.875-16.825-42.845-13.762-81.623-3.766A68.182,68.182,0,0,0,62.943,95.128a309.691,309.691,0,0,0-28.989,18.357C9.548,131.145-.5,145.78,4.069,156.977,7.343,164.994,17.2,169.02,33.462,169.02a153.207,153.207,0,0,0,22.4-1.909c26.462-3.979,59.7-13.789,93.581-27.63S213.928,109.38,235.6,93.7C260.005,76.034,270.057,61.4,265.484,50.2ZM23.117,153.56c-3.848,1.11-7.47.261-8.091-1.895s1.994-4.8,5.856-5.909,7.473-.261,8.093,1.895S26.967,152.444,23.117,153.56ZM109.53,37.075a56.464,56.464,0,0,1,73.624,30.917l0,0c1.435,3.514.19,7.83-3.7,12.843-15.61,20.14-63.992,39.879-89.221,36.444-6.287-.861-10.2-3.075-11.634-6.58A56.534,56.534,0,0,1,109.53,37.075Zm37.838,93.259c-3.766,1.359-7.438.753-8.2-1.356s1.672-4.922,5.441-6.284,7.438-.755,8.2,1.353S151.136,128.969,147.367,130.334ZM248.582,59.806c-3.848,1.11-7.473.261-8.093-1.895s2-4.8,5.856-5.909,7.47-.261,8.093,1.895S252.43,58.7,248.582,59.806Z",
  transform: "translate(5.775 40.815)",
  fill: "#15091b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.232,67.562h.179A4.392,4.392,0,0,0,39.8,63.343a37.389,37.389,0,0,1,8.53-22.228,4.392,4.392,0,0,0-6.722-5.655l-.042.051A46.233,46.233,0,0,0,31.027,62.994,4.392,4.392,0,0,0,35.232,67.562Z",
  transform: "translate(59.819 65.356)",
  fill: "#15091b"
}));

function SvgDiscoVoador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 281,
    height: 281,
    viewBox: "0 0 281 281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoVoador);
export default __webpack_public_path__ + "static/media/discoVoador.776b2347.svg";
export { ForwardRef as ReactComponent };